export default __webpack_public_path__ + "static/media/dollColoringSample.cca6198dd933f4394df8941a706953b0.png";